import { useCustomerNumberSearch } from "@/react/features/smp/dms/useCustomerNumberSearch";
import { useEffect } from "react";
import DynamicSelectCell from "./DynamicSelectCell";
import useEditableCell from "@/react/components/table/useEditableCell";

const DidNumberSelect = (props) => {
  const { dids, searchDids, isFetching } = useCustomerNumberSearch();

  const { value: currentDid } = useEditableCell(props);

  const subscriptionIdCell = props.row
    ?.getAllCells()
    .find((c) => c.column.id === "subscriptionId")
    ?.getContext();

  useEffect(() => {
    searchDids();
  }, [searchDids]);

  const options = (dids || []).map((did) => ({
    value: did.phoneNumber,
    label: did.phoneNumber,
  }));

  return subscriptionIdCell?.getValue() ? (
    currentDid
  ) : (
    <DynamicSelectCell
      {...props}
      options={options}
      isFetching={isFetching}
      testId={"phone-number-select"}
      placeholder={"Select Phone Number"}
    />
  );
};

export default DidNumberSelect;
